import React, { useEffect, useState } from "react";

const Orders = ({ active }) => {
  return (
    <svg
      className="w-6 h-6"
      viewBox="0 0 26 20"
      xmlns="http://www.w3.org/2000/svg"
      fill={active ? "#BA004F" : "#C1A4A4"}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.00011 1.99989C4.00011 0.895293 3.10459 -0.000488281 1.99993 -0.000488281C0.895549 -0.000488281 0 0.895293 0 1.99989C0 3.10412 0.895549 3.99953 1.99993 3.99953C3.10459 3.99953 4.00011 3.10412 4.00011 1.99989ZM9.00009 0.99969H25.0001C25.5524 0.99969 25.9999 1.44741 25.9999 1.99989C25.9999 2.55201 25.5524 2.9997 25.0001 2.9997H9.00009C8.44776 2.9997 8 2.55201 8 1.99989C8 1.44741 8.44776 0.99969 9.00009 0.99969ZM4.00011 9.99957C4.00011 8.89534 3.10459 7.99992 1.99993 7.99992C0.895549 7.99992 0 8.89534 0 9.99957C0 11.1046 0.895549 11.9999 1.99993 11.9999C3.10459 11.9999 4.00011 11.1046 4.00011 9.99957ZM9.00009 8.99976H25.0001C25.5524 8.99976 25.9999 9.44745 25.9999 9.99957C25.9999 10.552 25.5524 10.9998 25.0001 10.9998H9.00009C8.44776 10.9998 8 10.552 8 9.99957C8 9.44745 8.44776 8.99976 9.00009 8.99976ZM4.00011 17.9996C4.00011 16.8954 3.10459 16 1.99993 16C0.895549 16 0 16.8954 0 17.9996C0 19.1042 0.895549 19.9996 1.99993 19.9996C3.10459 19.9996 4.00011 19.1042 4.00011 17.9996ZM25.0001 16.9998H9.00009C8.44776 16.9998 8 17.4475 8 17.9996C8 18.5521 8.44776 18.9998 9.00009 18.9998H25.0001C25.5524 18.9998 25.9999 18.5521 25.9999 17.9996C25.9999 17.4475 25.5524 16.9998 25.0001 16.9998Z"
      />
    </svg>
  );
};

export default Orders;
